export default __webpack_public_path__ + "static/media/Logo1AEdicola.2478dcb7.png";